/* ============================================
   TUTU HOME - Theme JavaScript
   ============================================ */

(function () {
  'use strict';

  var Analytics = {
    config: window.TUTU_TRACKING || {},

    init: function () {
      this.config = window.TUTU_TRACKING || {};
      this.bindFormTracking();
      this.bindCheckoutTracking();

      if (this.config.pageType === 'product' && this.config.product) {
        this.trackProductView(this.config.product);
      }

      if (window.Shopify && window.Shopify.checkout && window.Shopify.checkout.order_id) {
        this.trackPurchase(window.Shopify.checkout);
      }
    },

    getCurrency: function () {
      return this.config.currency || 'EUR';
    },

    normalizeNumber: function (value) {
      var parsed = typeof value === 'string' ? parseFloat(value.replace(',', '.')) : Number(value);
      return isNaN(parsed) ? 0 : parsed;
    },

    log: function (name, payload) {
      if (this.config.debug && window.console) {
        console.log('[TUTU analytics]', name, payload);
      }
    },

    trackGA4: function (name, params) {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, params || {});
      }
      this.log(name, params || {});
    },

    trackMeta: function (name, params) {
      if (typeof window.fbq === 'function') {
        window.fbq('track', name, params || {});
      }
      this.log(name, params || {});
    },

    buildGaItem: function (item) {
      return {
        item_id: String(item.item_id || item.item_variant || ''),
        item_name: item.item_name || '',
        item_category: item.item_category || 'Rug',
        item_variant: item.item_variant ? String(item.item_variant) : '',
        price: this.normalizeNumber(item.price),
        quantity: item.quantity || 1
      };
    },

    buildMetaPayload: function (item, quantity) {
      var qty = quantity || item.quantity || 1;
      return {
        content_ids: [String(item.item_id || item.item_variant || '')],
        content_name: item.item_name || '',
        content_type: 'product',
        currency: this.getCurrency(),
        value: this.normalizeNumber(item.price) * qty
      };
    },

    buildItemFromAddResponse: function (item) {
      return {
        item_id: item.product_id || item.id || item.variant_id,
        item_name: item.product_title || item.title || '',
        item_category: item.product_type || 'Rug',
        item_variant: item.variant_id || item.id,
        price: (item.price || item.final_price || 0) / 100,
        quantity: item.quantity || 1
      };
    },

    buildItemFromProductContext: function (item) {
      return {
        item_id: item.item_id,
        item_name: item.item_name,
        item_category: item.item_category,
        item_variant: item.item_variant,
        price: this.normalizeNumber(item.price),
        quantity: item.quantity || 1
      };
    },

    trackProductView: function (item) {
      var trackedItem = this.buildItemFromProductContext(item);
      this.trackGA4('view_item', {
        currency: this.getCurrency(),
        value: this.normalizeNumber(trackedItem.price),
        items: [this.buildGaItem(trackedItem)]
      });
      this.trackMeta('ViewContent', this.buildMetaPayload(trackedItem, 1));
    },

    trackAddToCart: function (item) {
      var trackedItem = item.item_name ? item : this.buildItemFromAddResponse(item);
      this.trackGA4('add_to_cart', {
        currency: this.getCurrency(),
        value: this.normalizeNumber(trackedItem.price) * (trackedItem.quantity || 1),
        items: [this.buildGaItem(trackedItem)]
      });
      this.trackMeta('AddToCart', this.buildMetaPayload(trackedItem, trackedItem.quantity || 1));
    },

    trackBeginCheckout: function (items, value) {
      var list = items || [];
      var normalizedValue = this.normalizeNumber(value);
      this.trackGA4('begin_checkout', {
        currency: this.getCurrency(),
        value: normalizedValue,
        items: list.map(this.buildGaItem.bind(this))
      });
      this.trackMeta('InitiateCheckout', {
        content_ids: list.map(function (item) { return String(item.item_id || item.item_variant || ''); }),
        content_name: list.map(function (item) { return item.item_name; }).join(', '),
        content_type: 'product',
        currency: this.getCurrency(),
        value: normalizedValue
      });
    },

    trackPurchase: function (checkout) {
      if (!checkout || !checkout.order_id) return;

      var items = (checkout.line_items || []).map(function (item) {
        return {
          item_id: item.product_id || item.variant_id || item.id,
          item_name: item.title || item.name || '',
          item_category: item.product_type || 'Rug',
          item_variant: item.variant_id || item.id,
          price: item.price || 0,
          quantity: item.quantity || 1
        };
      });

      var value = this.normalizeNumber(checkout.total_price);
      this.trackGA4('purchase', {
        transaction_id: String(checkout.order_id),
        currency: checkout.currency || this.getCurrency(),
        value: value,
        items: items.map(this.buildGaItem.bind(this))
      });
      this.trackMeta('Purchase', {
        content_ids: items.map(function (item) { return String(item.item_id || item.item_variant || ''); }),
        content_type: 'product',
        currency: checkout.currency || this.getCurrency(),
        value: value
      });
    },

    trackCustom: function (name, params) {
      this.trackGA4(name, params || {});
    },

    bindFormTracking: function () {
      var newsletterForm = document.getElementById('FooterNewsletterForm');
      var contactForm = document.getElementById('ContactPageForm');

      if (newsletterForm) {
        newsletterForm.addEventListener('submit', function () {
          try { sessionStorage.setItem('tutu_newsletter_pending', '1'); } catch (e) {}
        });
      }

      if (contactForm) {
        contactForm.addEventListener('submit', function () {
          try { sessionStorage.setItem('tutu_contact_pending', '1'); } catch (e) {}
        });
      }

      if (document.querySelector('[data-newsletter-success]')) {
        try {
          if (sessionStorage.getItem('tutu_newsletter_pending') === '1') {
            this.trackCustom('newsletter_signup', { form_location: 'footer' });
            sessionStorage.removeItem('tutu_newsletter_pending');
          }
        } catch (e) {}
      }

      if (document.querySelector('[data-contact-success]')) {
        try {
          if (sessionStorage.getItem('tutu_contact_pending') === '1') {
            this.trackCustom('contact_submit', { form_location: 'contact_page' });
            sessionStorage.removeItem('tutu_contact_pending');
          }
        } catch (e) {}
      }
    },

    bindCheckoutTracking: function () {
      var self = this;

      document.addEventListener('click', function (event) {
        var checkoutLink = event.target.closest('a[href="/checkout"]');
        if (checkoutLink) {
          fetch('/cart.js')
            .then(function (response) { return response.json(); })
            .then(function (cart) {
              var items = (cart.items || []).map(function (item) {
                return {
                  item_id: item.product_id || item.id || item.variant_id,
                  item_name: item.product_title || item.title || '',
                  item_category: item.product_type || 'Rug',
                  item_variant: item.variant_id || item.id,
                  price: (item.price || 0) / 100,
                  quantity: item.quantity || 1
                };
              });
              self.trackBeginCheckout(items, (cart.total_price || 0) / 100);
            });
        }
      });
    }
  };

  /* --- Mobile Menu --- */
  function initMobileMenu() {
    var toggles = document.querySelectorAll('[data-menu-toggle]');
    var mobileNav = document.querySelector('[data-mobile-nav]');

    if (!mobileNav || !toggles.length) return;

    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        mobileNav.classList.toggle('is-open');
        document.body.style.overflow = mobileNav.classList.contains('is-open') ? 'hidden' : '';
      });
    });
  }

  /* --- Product Carousel (infinite loop) --- */
  function initCarousel() {
    var track = document.querySelector('[data-carousel-track]');
    var prevBtn = document.querySelector('[data-carousel-prev]');
    var nextBtn = document.querySelector('[data-carousel-next]');

    if (!track) return;

    var cards = Array.from(track.children);
    if (cards.length < 2) return;

    // Clone all cards for seamless infinite scroll
    cards.forEach(function (card) {
      var clone = card.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });

    // Also prepend clones for backward scrolling
    cards.forEach(function (card) {
      var clone = card.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.insertBefore(clone, track.firstChild);
    });

    // Start scrolled to the real items (skip prepended clones)
    var cardWidth = cards[0].offsetWidth + 20; // card width + gap
    track.scrollLeft = cards.length * cardWidth;

    var scrollAmount = cardWidth;
    var isScrolling = false;

    function checkInfiniteScroll() {
      var totalOriginal = cards.length * cardWidth;
      // If scrolled past the appended clones, jump back
      if (track.scrollLeft >= totalOriginal * 2) {
        track.style.scrollBehavior = 'auto';
        track.scrollLeft -= totalOriginal;
        track.style.scrollBehavior = '';
      }
      // If scrolled before the prepended clones, jump forward
      if (track.scrollLeft <= 0) {
        track.style.scrollBehavior = 'auto';
        track.scrollLeft += totalOriginal;
        track.style.scrollBehavior = '';
      }
      isScrolling = false;
    }

    track.addEventListener('scroll', function () {
      if (!isScrolling) {
        isScrolling = true;
        requestAnimationFrame(function () {
          setTimeout(checkInfiniteScroll, 100);
        });
      }
    }, { passive: true });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });
    }

    // Re-attach add-to-cart on cloned cards
    initAddToCart(track);
  }

  /* --- Add to Cart --- */
  function initAddToCart(scope) {
    var container = scope || document;
    container.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
      if (btn._atcBound) return;
      btn._atcBound = true;

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var variantId = this.getAttribute('data-variant-id');
        var button = this;

        button.classList.add('is-animating');
        setTimeout(function () { button.classList.remove('is-animating'); }, 500);

        if (!variantId) {
          button.classList.add('is-added');
          setTimeout(function () { button.classList.remove('is-added'); }, 1500);
          return;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
        })
        .then(function (res) { return res.json(); })
        .then(function (item) {
          Analytics.trackAddToCart(item);
          button.classList.add('is-added');
          setTimeout(function () { button.classList.remove('is-added'); }, 1500);
          // Update cart count and open the drawer (confirmation + surfaces free-shipping progress)
          CartDrawer.refresh(true);
        });
      });
    });
  }

  /* --- FAQ Accordion --- */
  function initFAQ() {
    var toggles = document.querySelectorAll('[data-faq-toggle]');

    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var item = this.closest('.faq__item');
        var isOpen = item.classList.contains('is-open');

        // Close all other items
        document.querySelectorAll('.faq__item.is-open').forEach(function (openItem) {
          if (openItem !== item) {
            openItem.classList.remove('is-open');
            openItem.querySelector('[data-faq-toggle]').setAttribute('aria-expanded', 'false');
          }
        });

        // Toggle current item
        item.classList.toggle('is-open', !isOpen);
        this.setAttribute('aria-expanded', String(!isOpen));
      });
    });
  }

  /* --- Cart Drawer (dynamic) --- */
  var CartDrawer = {
    drawer: null,
    t: {},
    getDisplayTitle: function (item) {
      var url = (item.url || '').toLowerCase();
      var handle = (item.handle || '').toLowerCase();
      var isEnglish = document.documentElement.lang === 'en';

      if (handle === 'michi-1' || url.indexOf('/products/michi-1') !== -1) {
        return isEnglish ? 'Happy Scooter Pup' : 'Perrito Feliz Patinete';
      }

      if (handle === 'langou' || url.indexOf('/products/langou') !== -1) {
        return isEnglish ? 'Happy Party Pup' : 'Perrito Feliz Fiesta';
      }

      return item.product_title;
    },

    init: function () {
      this.drawer = document.querySelector('[data-cart-drawer]');
      if (!this.drawer) return;

      // Read translations from data attributes
      var d = this.drawer;
      this.threshold = parseFloat(d.dataset.freeShippingThreshold || 75);
      this.symbol = d.dataset.currencySymbol || '€';
      this.contactUrl = d.dataset.contactUrl || '/pages/contact';
      this.shippingUrl = d.dataset.shippingUrl || '';
      this.refundUrl = d.dataset.refundUrl || '';
      this.t = {
        freeShipping: d.dataset.tFreeShipping,
        remaining: d.dataset.tRemaining,
        unlocked: d.dataset.tUnlocked,
        empty: d.dataset.tEmpty,
        discount: d.dataset.tDiscount,
        apply: d.dataset.tApply,
        subtotal: d.dataset.tSubtotal,
        shipping: d.dataset.tShipping,
        calc: d.dataset.tCalc,
        checkout: d.dataset.tCheckout,
        cont: d.dataset.tContinue,
        secure: d.dataset.tSecure,
        contact: d.dataset.tContact,
        returns: d.dataset.tReturns
      };

      this.bindOpen();
      this.refresh(false);
    },

    bindOpen: function () {
      var self = this;
      document.querySelectorAll('[data-cart-drawer-open]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          self.refresh(true);
        });
      });
    },

    open: function () {
      this.drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    },

    close: function () {
      this.drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    },

    bindClose: function () {
      var self = this;
      this.drawer.querySelectorAll('[data-cart-drawer-close]').forEach(function (btn) {
        btn.addEventListener('click', function () { self.close(); });
      });
    },

    formatMoney: function (cents) {
      return this.symbol + (cents / 100).toFixed(2).replace('.', ',');
    },

    refresh: function (andOpen) {
      var self = this;
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          self.render(cart);
          updateCartCount(cart.item_count);
          var drawerCount = self.drawer.querySelector('[data-cart-drawer-count]');
          if (drawerCount) drawerCount.textContent = cart.item_count;
          if (andOpen) self.open();
        });
    },

    render: function (cart) {
      this.renderShipping(cart);
      this.renderItems(cart);
      this.renderFooter(cart);
      this.bindClose();
    },

    renderShipping: function (cart) {
      var el = this.drawer.querySelector('[data-cart-drawer-shipping]');
      if (!el) return;
      if (this.threshold <= 0) { el.innerHTML = ''; return; }
      var totalEur = cart.total_price / 100;
      var remaining = Math.max(0, this.threshold - totalEur);
      var progress = Math.min((totalEur / this.threshold) * 100, 100);

      /* Desbloqueado: un solo mensaje, sin duplicados */
      var badgeLabel = remaining > 0 ? this.t.freeShipping : this.t.unlocked;
      var html = '<div class="cart-drawer__shipping-badge">' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">' +
        '<rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon>' +
        '<circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>' +
        '<span>' + badgeLabel + '</span></div>';

      if (remaining > 0) {
        var remainStr = this.symbol + remaining.toFixed(2).replace('.', ',');
        var msg = this.t.remaining.replace('{{ amount }}', remainStr);
        html += '<div class="cart-drawer__shipping-progress">' +
          '<div class="cart-drawer__shipping-bar"><div class="cart-drawer__shipping-fill" style="width:' + progress + '%"></div></div>' +
          '<p class="cart-drawer__shipping-msg">' + msg + '</p></div>';
      }
      el.innerHTML = html;
    },

    renderItems: function (cart) {
      var el = this.drawer.querySelector('[data-cart-drawer-items]');
      if (cart.item_count === 0) {
        el.innerHTML = '<div class="cart-drawer__empty"><p>' + this.t.empty + '</p></div>';
        return;
      }
      var self = this;
      var html = '';
      cart.items.forEach(function (item, i) {
        var imgSrc = item.image ? item.image.replace(/(\.\w+)(\?|$)/, '_200x$1$2') : '';
        var variantTitle = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
        var productTitle = self.getDisplayTitle(item);
        html += '<div class="cart-drawer__item" data-cart-item data-line="' + (i + 1) + '" data-key="' + item.key + '">' +
          '<div class="cart-drawer__item-img">' +
            (imgSrc ? '<img src="' + imgSrc + '" alt="' + productTitle + '" loading="lazy">' : '') +
          '</div>' +
          '<div class="cart-drawer__item-details">' +
            '<div class="cart-drawer__item-top"><div>' +
              '<h3 class="cart-drawer__item-name">' + productTitle + '</h3>' +
              (variantTitle ? '<p class="cart-drawer__item-variant">' + variantTitle + '</p>' : '') +
            '</div>' +
            '<button class="cart-drawer__item-remove" data-cart-remove-btn aria-label="Remove">' +
              '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">' +
              '<line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>' +
            '</button></div>' +
            '<div class="cart-drawer__item-bottom">' +
              '<span class="cart-drawer__item-price">' + self.formatMoney(item.final_line_price) + '</span>' +
              '<div class="cart-drawer__item-qty">' +
                '<button class="cart-drawer__qty-btn" data-qty-change="-1">\u2212</button>' +
                '<span class="cart-drawer__qty-val">' + item.quantity + '</span>' +
                '<button class="cart-drawer__qty-btn" data-qty-change="1">+</button>' +
              '</div>' +
            '</div>' +
          '</div></div>';
      });
      el.innerHTML = html;
      this.bindItemEvents();
    },

    renderFooter: function (cart) {
      var el = this.drawer.querySelector('[data-cart-drawer-footer]');
      if (cart.item_count === 0) { el.innerHTML = ''; return; }
      var quickLinks = '';
      if (this.shippingUrl) {
        quickLinks += '<a href="' + this.shippingUrl + '" class="cart-drawer__quick-link">' + this.t.shipping + '</a>';
      }
      if (this.refundUrl) {
        quickLinks += '<a href="' + this.refundUrl + '" class="cart-drawer__quick-link">' + this.t.returns + '</a>';
      }
      if (this.contactUrl) {
        quickLinks += '<a href="' + this.contactUrl + '" class="cart-drawer__quick-link">' + this.t.contact + '</a>';
      }

      el.innerHTML = '<div class="cart-drawer__footer">' +
        /* E3 2026-07-05: bloque descuento solo si data-t-discount no vacio (interruptor en snippets/cart-drawer.liquid) */
        (this.t.discount ? '<div class="cart-drawer__discount">' +
          '<input type="text" placeholder="' + this.t.discount + '" class="cart-drawer__discount-input">' +
          '<button class="cart-drawer__discount-btn">' + this.t.apply + '</button>' +
        '</div>' : '') +
        '<div class="cart-drawer__totals">' +
          '<div class="cart-drawer__total-row"><span>' + this.t.subtotal + '</span><span>' + this.formatMoney(cart.total_price) + '</span></div>' +
          '<div class="cart-drawer__total-row cart-drawer__total-row--muted"><span>' + this.t.shipping + '</span><span>' + ((this.threshold > 0 && cart.total_price / 100 >= this.threshold) ? ((document.documentElement.lang || '').indexOf('en') === 0 ? 'Free' : 'Gratis') : this.t.calc) + '</span></div>' +
          '<div class="cart-drawer__total-row cart-drawer__total-row--total"><span>Total</span><span>' + this.formatMoney(cart.total_price) + '</span></div>' +
        '</div>' +
        '<a href="/checkout" class="btn btn--primary cart-drawer__checkout-btn">' + this.t.checkout +
          ' <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">' +
          '<line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg></a>' +
        '<button class="btn btn--outline cart-drawer__continue-btn" data-cart-drawer-close>' + this.t.cont + '</button>' +
        '<div class="cart-drawer__payment-icons"><span>' + this.t.secure + '</span>' +
          '<div class="cart-drawer__payment-badges"><span class="cart-drawer__badge">VISA</span><span class="cart-drawer__badge">MC</span><span class="cart-drawer__badge">PP</span></div>' +
        '</div>' +
        (quickLinks ? '<div class="cart-drawer__quick-links">' + quickLinks + '</div>' : '') +
        '</div>';
    },

    bindItemEvents: function () {
      var self = this;
      this.drawer.querySelectorAll('[data-qty-change]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = this.closest('[data-cart-item]');
          var line = parseInt(item.dataset.line);
          var delta = parseInt(this.dataset.qtyChange);
          var qty = parseInt(item.querySelector('.cart-drawer__qty-val').textContent) + delta;
          if (qty < 0) qty = 0;
          self.updateLine(line, qty);
        });
      });
      this.drawer.querySelectorAll('[data-cart-remove-btn]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var line = parseInt(this.closest('[data-cart-item]').dataset.line);
          self.updateLine(line, 0);
        });
      });
    },

    updateLine: function (line, qty) {
      var self = this;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        self.render(cart);
        updateCartCount(cart.item_count);
        var drawerCount = self.drawer.querySelector('[data-cart-drawer-count]');
        if (drawerCount) drawerCount.textContent = cart.item_count;
      });
    }
  };

  /* --- Language Switcher --- */
  function initLangSwitcher() {
    var switchers = document.querySelectorAll('[data-lang-switcher]');
    if (!switchers.length) return;

    switchers.forEach(function (switcher) {
      var toggle = switcher.querySelector('[data-lang-toggle]');
      if (!toggle) return;

      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        // Close all other switchers first
        switchers.forEach(function (other) {
          if (other !== switcher) {
            other.classList.remove('is-open');
            var otherToggle = other.querySelector('[data-lang-toggle]');
            if (otherToggle) otherToggle.setAttribute('aria-expanded', 'false');
          }
        });
        switcher.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', switcher.classList.contains('is-open'));
      });
    });

    document.addEventListener('click', function (e) {
      switchers.forEach(function (switcher) {
        if (!switcher.contains(e.target)) {
          switcher.classList.remove('is-open');
          var toggle = switcher.querySelector('[data-lang-toggle]');
          if (toggle) toggle.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }

  /* --- Collection Page (Search / Sort / Filter / Loading) --- */
  function initCollection() {
    var section = document.querySelector('[data-collection-section]');
    if (!section) return;

    var grid = section.querySelector('[data-collection-grid]');
    var countEl = section.querySelector('[data-collection-count]');
    var paginationEl = section.querySelector('[data-collection-pagination]');
    var searchInput = section.querySelector('[data-collection-search]');
    var sortSelect = section.querySelector('[data-sort-select]');
    var sortTrigger = section.querySelector('[data-sort-trigger]');
    var sortDropdown = section.querySelector('[data-sort-dropdown]');
    var filterChips = section.querySelector('[data-filter-chips]');
    var noResults = section.querySelector('[data-collection-no-results]');
    var collectionUrl = section.dataset.collectionUrl || window.location.pathname;
    var productLabelSingular = section.dataset.productLabelSingular || 'producto';
    var productLabelPlural = section.dataset.productLabelPlural || 'productos';
    var countPrefix = section.dataset.countPrefix || '';

    var searchTimer = null;
    var isAjaxLoading = false;
    var filterCachedProducts = null;

    /* -- Skeleton loading -- */
    function showSkeleton() {
      isAjaxLoading = true;
      if (noResults) noResults.style.display = 'none';
      grid.innerHTML = buildSkeletonHTML(8);
      grid.classList.add('is-loading');
    }

    function buildSkeletonHTML(count) {
      var html = '';
      for (var i = 0; i < count; i++) {
        html += '<div class="collection-page__skeleton">' +
          '<div class="collection-page__skeleton-img"></div>' +
          '<div class="collection-page__skeleton-info">' +
            '<div class="collection-page__skeleton-line collection-page__skeleton-line--xs"></div>' +
            '<div class="collection-page__skeleton-line"></div>' +
            '<div class="collection-page__skeleton-line collection-page__skeleton-line--sm"></div>' +
          '</div></div>';
      }
      return html;
    }

    function hideSkeleton() {
      isAjaxLoading = false;
      grid.classList.remove('is-loading');
    }

    /* -- AJAX fetch & replace -- */
    function fetchCollection(url) {
      showSkeleton();

      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('[data-collection-grid]');
          var newCount = doc.querySelector('[data-collection-count]');
          var newPagination = doc.querySelector('[data-collection-pagination]');

          if (newGrid) {
            grid.innerHTML = newGrid.innerHTML;
            // Staggered fade-in
            grid.querySelectorAll('.collection-page__product').forEach(function (p, i) {
              p.style.animationDelay = (i * 0.06) + 's';
              p.classList.add('fade-in');
            });
          }
          if (newCount && countEl) countEl.innerHTML = newCount.innerHTML;
          if (newPagination && paginationEl) paginationEl.innerHTML = newPagination.innerHTML;

          hideSkeleton();
          initAddToCart(grid);
          bindPaginationLinks();
          applyHashFilter();

          // No products?
          if (!grid.querySelector('.collection-page__product')) {
            if (noResults) {
              if (!noResults.textContent.trim()) noResults.textContent = noResults.dataset.emptyText || '';
              noResults.style.display = '';
            }
          }
        })
        .catch(function () {
          hideSkeleton();
        });
    }

    function buildUrl(sort, tag) {
      var url = collectionUrl;
      var params = [];
      if (sort && sort !== 'manual') params.push('sort_by=' + sort);
      if (params.length) url += '?' + params.join('&');
      if (tag && tag !== 'all') url += '#' + tag;
      return url;
    }

    function updateVisibleCount(visibleCount) {
      if (countEl) {
        countEl.textContent = (countPrefix ? countPrefix + ' ' : '') + visibleCount + ' ' + (visibleCount === 1 ? productLabelSingular : productLabelPlural);
        countEl.style.opacity = '1';
      }
    }

    function applyFilterState(chip, updateHistory) {
      if (!chip || !filterChips) return;

      filterChips.querySelectorAll('.collection-page__chip').forEach(function (c) {
        c.classList.remove('collection-page__chip--active');
      });
      chip.classList.add('collection-page__chip--active');

      if (searchInput) searchInput.value = '';

      var filterValue = chip.dataset.filter;
      var productIds = chip.dataset.productIds ? chip.dataset.productIds.split(',') : [];
      var products = grid.querySelectorAll('.collection-page__product');

      if (!filterCachedProducts) {
        filterCachedProducts = Array.prototype.slice.call(products);
      }
      filterCachedProducts.forEach(function (p) { p.style.display = 'none'; });

      var skeletonCount = filterValue === 'all' ? 8 : Math.min(productIds.length, 8) || 4;
      var skeletonHTML = buildSkeletonHTML(skeletonCount);
      var skeletonWrapper = document.createElement('div');
      skeletonWrapper.className = 'collection-page__filter-skeleton';
      skeletonWrapper.innerHTML = skeletonHTML;
      grid.appendChild(skeletonWrapper);
      grid.classList.add('is-loading');
      if (countEl) countEl.style.opacity = '0';

      setTimeout(function () {
        if (skeletonWrapper.parentNode === grid) {
          grid.removeChild(skeletonWrapper);
        }
        grid.classList.remove('is-loading');

        var visibleCount = 0;
        filterCachedProducts.forEach(function (product) {
          var pid = product.dataset.productId || '';
          if (filterValue === 'all' || productIds.indexOf(pid) !== -1) {
            product.style.display = '';
            visibleCount++;
          } else {
            product.style.display = 'none';
          }
        });

        updateVisibleCount(visibleCount);
        if (noResults) {
          if (!noResults.textContent.trim()) noResults.textContent = noResults.dataset.emptyText || '';
          noResults.style.display = visibleCount === 0 ? '' : 'none';
        }
      }, 400);

      if (updateHistory) {
        history.replaceState(null, '', buildUrl(currentSort, filterValue));
      }
    }

    function applyHashFilter() {
      if (!filterChips) return;
      var hash = (window.location.hash || '').replace('#', '').toLowerCase();
      var target = hash ? filterChips.querySelector('[data-filter="' + hash + '"]') : null;
      if (!target) {
        target = filterChips.querySelector('[data-filter="all"]');
      }
      if (target) {
        applyFilterState(target, false);
      }
    }

    /* -- Sort -- */
    var currentSort = '';
    (function () {
      var sp = new URLSearchParams(window.location.search);
      if (sp.get('sort_by')) {
        currentSort = sp.get('sort_by');
        if (sortSelect) sortSelect.value = currentSort;
        if (sortDropdown) {
          sortDropdown.querySelectorAll('[data-sort-value]').forEach(function (btn) {
            btn.classList.toggle('collection-page__sort-option--active', btn.dataset.sortValue === currentSort);
          });
        }
      }
    })();

    /* Desktop: native select */
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        currentSort = this.value;
        var activeChip = filterChips ? filterChips.querySelector('.collection-page__chip--active') : null;
        var currentTag = activeChip ? activeChip.dataset.filter : 'all';
        var url = buildUrl(currentSort, currentTag);
        fetchCollection(url);
        history.replaceState(null, '', url);
      });
    }

    /* Mobile: icon trigger + dropdown */
    if (sortTrigger && sortDropdown) {
      sortTrigger.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = sortDropdown.classList.contains('collection-page__sort-dropdown--open');
        sortDropdown.classList.toggle('collection-page__sort-dropdown--open', !isOpen);
        sortTrigger.classList.toggle('collection-page__sort-trigger--active', !isOpen);
      });

      sortDropdown.addEventListener('click', function (e) {
        var opt = e.target.closest('[data-sort-value]');
        if (!opt) return;
        currentSort = opt.dataset.sortValue;

        sortDropdown.querySelectorAll('[data-sort-value]').forEach(function (btn) {
          btn.classList.remove('collection-page__sort-option--active');
        });
        opt.classList.add('collection-page__sort-option--active');

        sortDropdown.classList.remove('collection-page__sort-dropdown--open');
        sortTrigger.classList.remove('collection-page__sort-trigger--active');

        if (sortSelect) sortSelect.value = currentSort;

        var activeChip = filterChips ? filterChips.querySelector('.collection-page__chip--active') : null;
        var currentTag = activeChip ? activeChip.dataset.filter : 'all';
        var url = buildUrl(currentSort, currentTag);
        fetchCollection(url);
        history.replaceState(null, '', url);
      });

      document.addEventListener('click', function () {
        sortDropdown.classList.remove('collection-page__sort-dropdown--open');
        sortTrigger.classList.remove('collection-page__sort-trigger--active');
      });
    }

    /* -- Filter chips (client-side by space) -- */
    if (filterChips) {
      filterChips.addEventListener('click', function (e) {
        var chip = e.target.closest('[data-filter]');
        if (!chip || chip.classList.contains('collection-page__chip--active')) return;
        applyFilterState(chip, true);
      });
    }

    applyHashFilter();

    /* -- Search (client-side, debounced) -- */
    if (searchInput) {
      searchInput.addEventListener('input', function () {
        if (isAjaxLoading) return;
        var query = this.value.toLowerCase().trim();
        clearTimeout(searchTimer);

        searchTimer = setTimeout(function () {
          var products = grid.querySelectorAll('.collection-page__product');
          var visibleCount = 0;

          products.forEach(function (product) {
            var titleEl = product.querySelector('.collection-page__product-title');
            var typeEl = product.querySelector('.collection-page__product-type');
            var title = titleEl ? titleEl.textContent.toLowerCase() : '';
            var type = typeEl ? typeEl.textContent.toLowerCase() : '';

            if (!query || title.indexOf(query) !== -1 || type.indexOf(query) !== -1) {
              product.style.display = '';
              visibleCount++;
            } else {
              product.style.display = 'none';
            }
          });

          if (noResults) {
            if (!noResults.textContent.trim()) noResults.textContent = noResults.dataset.emptyText || '';
            noResults.style.display = (visibleCount === 0 && query) ? '' : 'none';
          }
        }, 300);
      });
    }

    /* -- Pagination via AJAX -- */
    function bindPaginationLinks() {
      if (!paginationEl) return;
      paginationEl.querySelectorAll('a.collection-page__page-btn').forEach(function (link) {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          fetchCollection(this.href);
          history.replaceState(null, '', this.href);
          section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
    }

    bindPaginationLinks();
  }

  /* --- Sticky Header with Transparent State --- */
  function initStickyHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;

    var isTransparentPage = document.querySelector('.hero') !== null;

    if (isTransparentPage) {
      header.classList.add('header--transparent');
    }

    window.addEventListener('scroll', function () {
      var currentScroll = window.pageYOffset;

      if (currentScroll > 50) {
        header.style.boxShadow = '0 2px 10px rgba(0,0,0,0.06)';
        if (isTransparentPage) {
          header.classList.remove('header--transparent');
          header.classList.add('header--scrolled');
        }
      } else {
        header.style.boxShadow = 'none';
        if (isTransparentPage) {
          header.classList.add('header--transparent');
          header.classList.remove('header--scrolled');
        }
      }
    }, { passive: true });
  }

  /* --- Text fixups for stale cached labels --- */
  function applyTextFixups() {
    var isEnglish = document.documentElement.lang === 'en';
    var labels = document.querySelectorAll('.contact-page__detail-label');
    var stalePhoneKey = isEnglish ? 'Translation missing: en.contact.info_phone_label' : 'Translation missing: es.contact.info_phone_label';
    var fallbackPhoneLabel = isEnglish ? 'Phone' : 'Teléfono';
    var sharedTextFixups = {
      'Alfombras y piezas para el hogar pensadas para el d\u94c6a a d\u94c6a: f\u8c29ciles de cuidar, agradables de vivir': 'Alfombras y piezas para el hogar pensadas para el día a día: fáciles de cuidar, agradables de vivir',
      '\u8137nete a la familia TUTU': 'Únete a la familia TUTU',
      'Recibe inspiraci\u8d38n, novedades y acceso anticipado a nuevos dise\u5e3dos.': 'Recibe inspiración, novedades y acceso anticipado a nuevos diseños.',
      '\u6f0f 2026 TUTU HOME. Todos los derechos reservados.': '© 2026 TUTU HOME. Todos los derechos reservados.'
    };

    document.querySelectorAll('.footer__tagline, .footer__newsletter-title, .footer__newsletter-desc, .footer__copyright').forEach(function (node) {
      var text = (node.textContent || '').trim();
      if (sharedTextFixups[text]) {
        node.textContent = sharedTextFixups[text];
      }
    });

    labels.forEach(function (label) {
      if ((label.textContent || '').trim() === stalePhoneKey) {
        label.textContent = fallbackPhoneLabel;
      }
    });

    var legacyCollectionRedirects = {
      '/collections/frontpage': '/collections/alfombras-lavables',
      '/collections/no-1': '/collections/alfombras-lavables',
      '/collections/bathroom': '/collections/alfombras-bano',
      '/collections/kitchen': '/collections/hogar',
      '/collections/entryway': '/collections/alfombras-entrada',
      '/collections/bedroom': '/collections/alfombras-dormitorio',
      '/en/collections/frontpage': '/en/collections/alfombras-lavables',
      '/en/collections/no-1': '/en/collections/alfombras-lavables',
      '/en/collections/bathroom': '/en/collections/alfombras-bano',
      '/en/collections/kitchen': '/en/collections/hogar',
      '/en/collections/entryway': '/en/collections/alfombras-entrada',
      '/en/collections/bedroom': '/en/collections/alfombras-dormitorio'
    };
    var legacyBlogRedirects = {
      '/blogs/noticias': '/blogs/news',
      '/en/blogs/noticias': '/en/blogs/news'
    };

    var currentPath = window.location.pathname;
    if (legacyCollectionRedirects[currentPath]) {
      var redirectedUrl = legacyCollectionRedirects[currentPath] + window.location.search + window.location.hash;
      window.location.replace(redirectedUrl);
      return;
    }

    if (legacyBlogRedirects[currentPath]) {
      var redirectedBlogUrl = legacyBlogRedirects[currentPath] + window.location.search + window.location.hash;
      window.location.replace(redirectedBlogUrl);
      return;
    }

    document.querySelectorAll('a[href*="/collections/all#"]').forEach(function (link) {
      var href = link.getAttribute('href') || '';
      var match = href.match(/^(\/en)?\/collections\/all#(bathroom|kitchen|entryway|bedroom)$/);
      if (match) {
        var prefix = match[1] || (isEnglish ? '/en' : '');
        var rerouteMap = {
          bathroom: '/collections/alfombras-bano',
          kitchen: '/collections/hogar',
          entryway: '/collections/alfombras-entrada',
          bedroom: '/collections/alfombras-dormitorio'
        };
        link.setAttribute('href', prefix + rerouteMap[match[2]]);
      }
    });

    if (isEnglish) {
      var footerLabels = {
        '/en/policies/refund-policy': 'Returns',
        '/en/policies/shipping-policy': 'Shipping',
        '/en/policies/legal-notice': 'Legal Notice'
      };

      document.querySelectorAll('.footer__legal-link').forEach(function (link) {
        var href = link.getAttribute('href') || '';
        if (footerLabels[href]) {
          link.textContent = footerLabels[href];
        }
      });

      var filterLabels = {
        'baño': 'Bathroom',
        'bano': 'Bathroom',
        'cocina': 'Kitchen',
        'entrada': 'Entryway',
        'dormitorio': 'Bedroom',
        'decorativas': 'Decorative'
      };

      document.querySelectorAll('.collection-page__chip').forEach(function (chip) {
        var text = (chip.textContent || '').trim().toLowerCase();
        if (filterLabels[text]) {
          chip.textContent = filterLabels[text];
        }
      });
    } else {
      var spanishTextFixups = {
        'Que tu casa sea mas tu': 'Que tu casa sea más tú',
        'Descubre la coleccion': 'Descubre la colección',
        'En TUTU HOME creemos que una alfombra no solo decora: tambien hace la rutina mas comoda. Nuestra coleccion flocada esta pensada para espacios reales, con disenos faciles de integrar, faciles de cuidar y agradables para el uso diario.': 'En TUTU HOME creemos que una alfombra no solo decora: también hace la rutina más cómoda. Nuestra colección flocada está pensada para espacios reales, con diseños fáciles de integrar, fáciles de cuidar y agradables para el uso diario.',
        'Conocenos': 'Conócenos',
        'POR QUE TUTU HOME': 'POR QUÉ TUTU HOME',
        'Necesitas ayuda para elegir?': '¿Necesitas ayuda para elegir?',
        'Piezas pensadas para hacer mas agradable lo cotidiano': 'Piezas pensadas para hacer más agradable lo cotidiano',
        'Disenos suaves, practicos y faciles de integrar en los espacios que mas usas cada dia.': 'Diseños suaves, prácticos y fáciles de integrar en los espacios que más usas cada día.',
        'Bano, entrada, junto a la cama o zonas de paso: la coleccion esta pensada para espacios que de verdad se usan cada dia.': 'Baño, entrada, junto a la cama o zonas de paso: la colección está pensada para espacios que de verdad se usan cada día.',
        'Faciles de mantener': 'Fáciles de mantener',
        'Tacto suave, cuidado sencillo y base antideslizante para usarla con comodidad desde el primer dia.': 'Tacto suave, cuidado sencillo y base antideslizante para usarla con comodidad desde el primer día.',
        'Envio gratis desde EUR50, devolucion en 14 dias y ayuda directa por email para resolver dudas antes de decidir.': 'Envío gratis desde EUR50, devolución en 14 días y ayuda directa por email para resolver dudas antes de decidir.',
        'funciona mejor en rincones frescos y faciles de vivir': 'funciona mejor en rincones frescos y fáciles de vivir',
        'Encaja bien donde quieres una pisada mas suave y una sensacion mas ligera: salida del baño, lado de la cama, entrada o rincones que agradecen un acento mas calmado sin volverse pesados.': 'Encaja bien donde quieres una pisada más suave y una sensación más ligera: salida del baño, lado de la cama, entrada o rincones que agradecen un acento más calmado sin volverse pesados.',
        'Baños, entradas, lados de la cama y rincones tranquilos que agradecen un acento mas ligero y fresco.': 'Baños, entradas, lados de la cama y rincones tranquilos que agradecen un acento más ligero y fresco.',
        'Personas que buscan suavidad, un dibujo o color mas calmado y una alfombra facil de colocar en espacios de uso real.': 'Personas que buscan suavidad, un dibujo o color más calmado y una alfombra fácil de colocar en espacios de uso real.',
        'Si dudas entre medidas, elige la que suavice el rincon sin tapar todos los bordes para que la estancia siga viendose ligera y abierta.': 'Si dudas entre medidas, elige la que suavice el rincón sin tapar todos los bordes para que la estancia siga viéndose ligera y abierta.'
      };

      document.querySelectorAll('.hero__title, .brand-story__description, .brand-story .btn, .buying-reasons__title, .buying-reasons__description, .buying-reasons__card-title, .buying-reasons__card-text, .product-fit-guide__title, .product-fit-guide__description, .product-fit-guide__text').forEach(function (node) {
        var text = (node.textContent || '').trim();
        if (spanishTextFixups[text]) {
          node.textContent = spanishTextFixups[text];
        }
      });
    }
  }

  function initTextFixups() {
    applyTextFixups();
    window.setTimeout(applyTextFixups, 250);
    window.setTimeout(applyTextFixups, 1200);

    if (window.MutationObserver) {
      var observer = new MutationObserver(function () {
        applyTextFixups();
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  }

  /* --- Update header cart count with bump animation --- */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-count', count);
      if (count > 0) {
        el.style.display = '';
        el.classList.remove('is-bump');
        void el.offsetWidth; // force reflow
        el.classList.add('is-bump');
      }
    });
  }

  /* --- Product Detail Page --- */
  function initProductPage() {
    var pdp = document.querySelector('[data-product-page]');
    if (!pdp) return;

    // Gallery thumbnails
    var mainImg = pdp.querySelector('#pdp-main-img');
    var thumbs = pdp.querySelectorAll('[data-thumb-btn]');
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        thumbs.forEach(function(t) { t.classList.remove('pdp__thumb--active'); });
        thumb.classList.add('pdp__thumb--active');
        if (mainImg) {
          mainImg.style.opacity = '0';
          setTimeout(function() {
            mainImg.src = thumb.getAttribute('data-image-url');
            mainImg.style.opacity = '1';
          }, 200);
        }
      });
    });

    // Variant selection (sizes & colors)
    var variantId = pdp.querySelector('[data-variant-id]');
    var priceEl = pdp.querySelector('[data-product-price]');
    var comparePriceEl = pdp.querySelector('[data-compare-price]');
    var priceSaveEl = pdp.querySelector('[data-price-save]');
    var addText = pdp.querySelector('[data-add-text]');
    var selectedColor = pdp.querySelector('[data-selected-color]');
    var addCartBtn = pdp.querySelector('[data-btn-add-cart]');
    var buyNowBtn = pdp.querySelector('[data-buy-now]');

    function syncPurchaseState(variant) {
      var variantAvailable = Boolean(variant && variant.available);

      if (addCartBtn) {
        addCartBtn.disabled = !variantAvailable;
      }

      if (buyNowBtn) {
        buyNowBtn.disabled = !variantAvailable;
        buyNowBtn.hidden = !variantAvailable;
        buyNowBtn.setAttribute('aria-hidden', variantAvailable ? 'false' : 'true');
      }
    }

    function findCurrentVariant() {
      if (!productJson || !productJson.variants || !productJson.variants.length) return null;

      var currentId = variantId ? String(variantId.value) : '';
      if (currentId) {
        var selectedById = productJson.variants.find(function(v) { return String(v.id) === currentId; });
        if (selectedById) return selectedById;
      }

      var selectedOptions = [];
      productJson.options.forEach(function(opt, i) {
        var activeBtn = pdp.querySelector('[data-option-index="' + i + '"] .pdp__size-btn--active, [data-option-index="' + i + '"] .pdp__color-swatch--active');
        if (activeBtn) selectedOptions.push(activeBtn.getAttribute('data-option-value'));
      });

      if (selectedOptions.length) {
        var selectedByOptions = productJson.variants.find(function(v) {
          return v.options.every(function(o, i) { return o === selectedOptions[i]; });
        });
        if (selectedByOptions) return selectedByOptions;
      }

      return productJson.variants[0];
    }

    // Get product JSON from Shopify
    var productJson = null;
    var productUrl = pdp.getAttribute('data-product-url');

    // If stale HTML still exposes the buy-now button, match the server-rendered add-to-cart state immediately.
    if (addCartBtn) {
      syncPurchaseState({ available: !addCartBtn.disabled });
    }

    if (productUrl) {
      fetch(productUrl + '.js')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          productJson = data;
          bindOptionButtons();
          var initialVariant = findCurrentVariant();
          if (initialVariant) syncPurchaseState(initialVariant);
        });
    }

    function bindOptionButtons() {
      // Size buttons
      pdp.querySelectorAll('.pdp__size-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var grid = btn.closest('.pdp__size-grid');
          grid.querySelectorAll('.pdp__size-btn').forEach(function(b) { b.classList.remove('pdp__size-btn--active'); });
          btn.classList.add('pdp__size-btn--active');
          updateVariant();
        });
      });
      // Color swatches
      pdp.querySelectorAll('.pdp__color-swatch').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var row = btn.closest('.pdp__color-row');
          row.querySelectorAll('.pdp__color-swatch').forEach(function(b) { b.classList.remove('pdp__color-swatch--active'); });
          btn.classList.add('pdp__color-swatch--active');
          if (selectedColor) selectedColor.textContent = btn.getAttribute('data-option-value');
          updateVariant();
        });
      });
    }

    function updateVariant() {
      var variant = findCurrentVariant();
      if (variant) {
        variantId.value = variant.id;
        if (window.TUTU_TRACKING && window.TUTU_TRACKING.product) {
          window.TUTU_TRACKING.product.item_variant = variant.id;
          window.TUTU_TRACKING.product.price = variant.price / 100;
        }
        var formatted = (variant.price / 100).toFixed(2).replace('.', ',');
        priceEl.textContent = '€' + formatted;
        if (addText) addText.textContent = (variant.available ? addText.textContent.split('—')[0].trim() + ' — €' + formatted : addText.textContent);
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          var compFormatted = (variant.compare_at_price / 100).toFixed(2).replace('.', ',');
          if (comparePriceEl) { comparePriceEl.textContent = '€' + compFormatted; comparePriceEl.style.display = ''; }
          if (priceSaveEl) {
            var savings = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
            priceSaveEl.textContent = '−' + savings + '%';
            priceSaveEl.style.display = '';
          }
        } else {
          if (comparePriceEl) comparePriceEl.style.display = 'none';
          if (priceSaveEl) priceSaveEl.style.display = 'none';
        }
        syncPurchaseState(variant);
      }
    }

    // Accordion
    pdp.querySelectorAll('[data-accordion-trigger]').forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        var item = trigger.closest('[data-accordion-item]');
        item.classList.toggle('pdp__acc-item--open');
      });
    });

    // Add to cart via AJAX with loading animation
    var cartForm = pdp.querySelector('form[action*="/cart/add"]');
    if (cartForm) {
      cartForm.addEventListener('submit', function(e) {
        e.preventDefault();
        var id = cartForm.querySelector('[data-variant-id]').value;
        if (addCartBtn) addCartBtn.classList.add('is-loading');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(id), quantity: 1 }] })
        })
        .then(function(r) { return r.json(); })
        .then(function(response) {
          var item = response.items && response.items.length ? response.items[0] : response;
          Analytics.trackAddToCart(item);
          return fetch('/cart.js');
        })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          if (addCartBtn) addCartBtn.classList.remove('is-loading');
          updateCartCount(cart.item_count);
          CartDrawer.render(cart);
          var drawerCount = document.querySelector('[data-cart-drawer-count]');
          if (drawerCount) drawerCount.textContent = cart.item_count;
          // Open the drawer as confirmation (surfaces free-shipping progress + one-tap checkout)
          CartDrawer.open();
        })
        .catch(function() {
          if (addCartBtn) addCartBtn.classList.remove('is-loading');
        });
      });
    }

    // Buy Now → direct checkout
    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', function(event) {
        event.preventDefault();
        var id = pdp.querySelector('[data-variant-id]').value;
        var selectedVariant = productJson && productJson.variants
          ? productJson.variants.find(function(v) { return String(v.id) === String(id); })
          : null;

        if (buyNowBtn.disabled || buyNowBtn.hidden || (selectedVariant && !selectedVariant.available)) {
          return;
        }

        if (window.TUTU_TRACKING && window.TUTU_TRACKING.product) {
          var item = Analytics.buildItemFromProductContext(window.TUTU_TRACKING.product);
          Analytics.trackBeginCheckout([item], item.price);
        }
        setTimeout(function () {
          window.location.href = '/cart/' + id + ':1';
        }, 120);
      });
    }
  }

  /* --- Init --- */
  document.addEventListener('DOMContentLoaded', function () {
    initMobileMenu();
    initCarousel();
    initAddToCart();
    initFAQ();
    Analytics.init();
    CartDrawer.init();
    initLangSwitcher();
    initStickyHeader();
    initTextFixups();
    initCollection();
    initProductPage();
  });
})();
